/**
 * GiveGift.js
 *
 * Gift sending page for the /send route. Opens the gift form in a drawer
 * over a blank backdrop — same experience as gifting from a pool post.
 */

import { useNavigate } from 'react-router-dom';
import GiftDrawer from './components/GiftDrawer';

function GiveGift() {
  const navigate = useNavigate();
  return <GiftDrawer onSuccess={() => {}} onClose={() => navigate(-1)} />;
}

export default GiveGift;
